
import { portalapi } from 'src/helpers/axios'
import { ErrorService } from "../helpers/errorplugin"
import { productFromID } from '../helpers/pricing.plugin'
const $log = ErrorService


const getDefaultState = () => {
  return {
    activeProduct: undefined, // product object for active entitlement
    activeUntil: undefined, // date of expiry for active entitlement
    lastActiveProduct: undefined, // product object for last entitlement
    lastActiveUntil: undefined, // date of expiry for last entitlement
    subscription: undefined, // subscription object
    subscribedProduct: undefined, // flattened property from subscription,
    baseEntitlements: undefined //all active and future entitlements
  }
}

const state = getDefaultState()

const mutations = {
  setActiveProduct: function(state, newProduct){    
    state.activeProduct = newProduct
  },
  setLastActiveProduct: function(state, newProduct){
    state.lastActiveProduct = newProduct
  },
  setActiveUntil: function(state, until){
    state.activeUntil = until
  },
  setLastActiveUntil: function(state, until){
    state.lastActiveUntil = until
  },
  setBaseEntitlements: function(state, entitlements) {
    state.baseEntitlements = entitlements
  },
  setSubscription: function(state, value){
    state.subscription = value
  },
  setSubscribedProduct: function(state, value){
    state.subscribedProduct = value
  },
  reset(state, type){
    Object.assign(state, getDefaultState())
  }
}


const getters = {
  getActiveProduct: state => state.activeProduct,
  getLastActiveProduct: state => state.lastActiveProduct,
  getActiveUntil: state => state.activeUntil,
  getLastActiveUntil: state => state.lastActiveUntil,
  getBaseEntitlements: state => state.baseEntitlements,
  getSubscription: state => state.subscription,
  getSubscribedProduct: state => state.subscribedProduct
}

const actions = {
  setActiveProduct: ({dispatch, commit }, payload) => {
    if ( payload != null ){
      commit("setActiveProduct", payload.product)
      commit("setActiveUntil", new Date(payload.until))  
    } else {
      commit("setActiveProduct", undefined)
      commit("setActiveUntil", undefined)  
    }
  },
  setLastActiveProduct: ({dispatch, commit }, payload) => {
    if ( payload != null ){
      commit("setLastActiveProduct", payload.product)
      commit("setLastActiveUntil", new Date(payload.until))  
    } else {
      commit("setLastActiveProduct", undefined)
      commit("setLastActiveUntil", undefined)  
    }
  },
  setBaseEntitlements: ({dispatch, commit}, payload) => {
    if ( payload != null){
      commit("setBaseEntitlements", payload)
    } else {
      commit("setBaseEntitlements", undefined)
    }
  },
  setSubscription: ({dispatch, commit }, payload) => {
    if ( payload != null ) {
      commit("setSubscription", payload)
            $log.onDebug('initialise subscription value as ' + JSON.stringify(payload))
      commit("setSubscribedProduct", payload.product)
    } else {
      commit("setSubscription", undefined)
      $log.onDebug('Subscription is null - ' + JSON.stringify(payload))
      commit("setSubscribedProduct", undefined)
    }
  },
  initialiseSubscription: ({dispatch, commit}) => {
    $log.onDebug('initialise subscription started')
    portalapi
        .get("/myaccount/subscription")
        .then((response) => {
          if (response.data != null) {
            commit("setSubscription", response.data);
            if (response.data.special != null) {
              commit("pricing/setSpecial", response.data.special, {root: true})
            }
          }
          else {
            commit("setSubscription", undefined);
          }
        })
        .catch((error) => {
          JSON.parse(JSON.stringify(error)).status === 403 ? 
          commit("setSubscription", undefined) :
          $log.onError("unable to fetch subscription.");
        });
    dispatch("updatePlan");
  },
  updatePlan: ({ dispatch, commit }) => {
    portalapi.get('/myaccount/currententitlements')
      .then((response) => {
        $log.onError('entitlements recieved')
        // do something with both responses
        let rd = response.data;
  
        let baseEntitlements = rd.filter((entitlement) => entitlement.product.serviceType === "BASE");
  
        let activeEntitlement = null;
        let lastActiveEntitlement = null;
  
        if (baseEntitlements.length > 0) {
          $log.onError('setting the active entitlement if possible');
          activeEntitlement = baseEntitlements.find((entitlement) => {
            let entitlementStartDate = new Date(entitlement.datefrom);
            let entitlementEndDate = new Date(entitlement.dateto);
            let currentDate = new Date();
            return entitlementStartDate <= currentDate && entitlementEndDate > currentDate;
          });
          $log.onError('value set to - ' + JSON.stringify(activeEntitlement));
    
          commit("setBaseEntitlements", baseEntitlements)
          baseEntitlements.sort((a, b) => {
            const endDateA = new Date(a.dateto); // Use 'dateto' for sorting
            const endDateB = new Date(b.dateto);
            return endDateB - endDateA; // Sort in descending order
          });
  
  
          lastActiveEntitlement = baseEntitlements.length > 0 ? baseEntitlements[0] : null;
          $log.onError('activeEntitlement is ' + JSON.stringify(activeEntitlement))
          if (activeEntitlement != null) {
            $log.onDebug("got an entitlement");
            $log.onDebug("Active Entitlement:", JSON.stringify(activeEntitlement));
            let product = productFromID(activeEntitlement.product.productid);
            commit("setActiveProduct", product);
            commit("setActiveUntil", activeEntitlement.dateto);
          } else {
            $log.onDebug("myaccount/currententitlements: could not find entitlement or active product");
            commit("setActiveProduct", null);
          }
    
          if (lastActiveEntitlement != null) {
            $log.onDebug("got an entitlement");
            $log.onDebug("Last Active Entitlement:", lastActiveEntitlement);
            let product = productFromID(lastActiveEntitlement.product.productid);
            commit("setLastActiveProduct", product);
            commit("setLastActiveUntil", lastActiveEntitlement.dateto);
          } else {
            $log.onDebug("myaccount/currententitlements: could not find entitlement or active product");
            commit("setLastActiveProduct", null);
          }
        }
  
      }, error => {
        $log.onDebug("Failed to load current account status:" + JSON.stringify(error));
      });
  },
  reset({commit}){
    commit('reset')
  }

  
        // if (activeEntitlement) {
        //   $log.onDebug("got an entitlement");
        //   $log.onDebug("Active Entitlement:", JSON.stringify(activeEntitlement));
        //   let product = productFromID(activeEntitlement.product.productid);
        //   commit("setActiveProduct", product);
        //   commit("setActiveUntil", activeEntitlement.dateto);
        // } else {
        //   $log.onDebug("myaccount/currententitlements: could not find entitlement or active product");
        //   commit("setActiveProduct", null);
        // }
  
        // if (lastActiveEntitlement) {
        //   $log.onDebug("got an entitlement");
        //   $log.onDebug("Last Active Entitlement:", lastActiveEntitlement);
        //   let product = productFromID(lastActiveEntitlement.product.productid);
        //   commit("setLastActiveProduct", product);
        //   commit("setLastActiveUntil", lastActiveEntitlement.dateto);
        // } else {
        //   $log.onDebug("myaccount/currententitlements: could not find entitlement or active product");
        //   commit("setLastActiveProduct", null);
        // }
}
      
export const plan = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  };
    
